import bsCustomFileInput from 'bs-custom-file-input';

$(function(){
    bsCustomFileInput.init()
});



// WEBPACK FOOTER //
// ./src/Resources/assets/js/UI/custom-file-input.js